(() => {
  const shopNowButtons = document.querySelectorAll('[data-ba-shop-now]');

  shopNowButtons.forEach((button) => {
    button.addEventListener('click', (event) => {
      const target =
        document.querySelector('basic-bundle-builder') ||
        document.querySelector('.product-form') ||
        document.querySelector('[id^="ProductInfo-"]');

      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });
})();
